import { render, staticRenderFns } from "./HealthInsurance.vue?vue&type=template&id=321f8d55"
import script from "./HealthInsurance.vue?vue&type=script&lang=ts"
export * from "./HealthInsurance.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports